import {
  DatabaseService,
  MercuryPayment,
  MercuryPaymentData,
  MercuryPaymentRepository,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getMercuryPaymentRepository(
  databaseService: DatabaseService,
): MercuryPaymentRepository {
  return getGenericRepository<MercuryPayment, MercuryPaymentData>(
    () => DatabaseCollection.MERCURY_PAYMENTS,
    databaseService,
  );
}
